import React, { Component } from 'react';
import { NavLink } from "react-router-dom"
import { authentication } from '../services/Authentication';
import { BehaviorSubject } from 'rxjs';
import helpers from '../Function';
import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalFooter from "react-bootstrap/ModalFooter";
import ModalTitle from "react-bootstrap/ModalTitle";
import $ from "jquery";
import { config } from '../Constants';

const currentSubject = new BehaviorSubject(JSON.parse(localStorage.getItem('currentUser')));

export default class MenuLeft extends Component {

    componentDidMount() {
        helpers.checklogin(this.state.jwt);
    }

    constructor(props) {
        super(props);

        const { name, user_type, user_id, user_permission, jwt } = authentication.currentUserValue;
        this.state = {
            name: name,
            miss_suc: helpers.getUserType(user_type, "suc"),
            miss_su: helpers.getUserType(user_type, "su"),
            miss_acc: helpers.getUserType(user_type, "acc"),
            user_permissions: user_permission,
            logoutIsOpen: false,
            jwt: jwt,
            count: 0,
            user_id: user_id
        }
        //console.log("*******"+JSON.stringify(authentication));
        this.LogoutSubmit = this.LogoutSubmit.bind(this);
        this.closeLogoutCancel = this.closeLogoutCancel.bind(this);
        this.openLogoutCancel = this.openLogoutCancel.bind(this);


        $("#root").addClass("wrapper");
        $("body").removeClass("login-page");

        this.checkpermission();
        this.chat()
    }


    LogoutSubmit() {
        authentication.logout();
        //history.push('/login');
    }

    closeLogoutCancel() {
        this.setState({ logoutIsOpen: false });
    }

    openLogoutCancel() {
        this.setState({ logoutIsOpen: true });
    }

    checkpermission() {
        if (this.state.user_permissions.length < 263) {
            console.log(this.state.user_permissions.length)
            localStorage.removeItem("currentUser")
            window.location.assign('/')
        } else {
            console.log(this.state.user_permissions.length)
        }
    }

    chat() {
        /*
        const requestOptions = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            },
        };

        fetch(config.url.API_URL + '/getunread/?user_id=' + this.state.user_id, requestOptions)
            .then(res => res.json())
            .then(data => {
                var DataFrom = data.data
                this.setState({
                    count: DataFrom
                });
            });
*/
    }

    render() {
        //console.log("::::::::::::::::::::::::::"+this.state.miss_su)
        //console.log("::::::::::::::::::::::::::"+this.state.miss_suc)
        // var elemUser;

        // if (this.state.miss_su || this.state.miss_suc || this.state.miss_acc) {
        //     elemUser = (<li className="nav-item has-treeview">
        //         <NavLink to="/users" className="nav-link">
        //             <img src={"../dist/img/icon/ic_moreuser_01.png"} className="menu-icon" />
        //             <p>Users</p>
        //         </NavLink>
        //     </li>)
        // }

        return (
            <aside className="main-sidebar sidebar-light-primary elevation-4">
                <a href="/" className="brand-link">
                    <img src={"../dist/img/log_NDV.png"} alt="Nirvana Logo" className="brand-image" />
                </a>
                <div className="sidebar">
                    <div className="user-panel d-flex">
                        <div className="image">
                            <img src={"../dist/img/icon/ic_user_01.png"} alt="User_Image" />
                        </div>
                        <div className="info">
                            <a href="" className="d-block">{this.state.name}</a>
                            <a href="" className="d-block">Admin</a>
                        </div>
                    </div>
                    <nav className="mt-2">

                        <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
                            {((this.state.user_permissions[0].permission == 1 || this.state.user_permissions[1].permission == 1 || this.state.user_permissions[2].permission == 1 || this.state.user_permissions[196].permission == 1) &&
                                <li className="nav-item has-treeview">
                                    <NavLink exact to="/" className="nav-link">
                                        <img src={"../dist/img/icon/ic_menu_01.png"} className="menu-icon" alt="" />
                                        <p>Dashboard</p>
                                    </NavLink>
                                </li>
                            )}
                                <>
                                {((this.state.user_permissions[23].permission == 1 || 
                                    this.state.user_permissions[27].permission == 1 || 
                                    this.state.user_permissions[31].permission == 1 || 
                                    this.state.user_permissions[142].permission == 1 || 
                                    this.state.user_permissions[156].permission == 1 || 
                                    this.state.user_permissions[100].permission == 1 || 
                                    this.state.user_permissions[17].permission == 1) &&
                                
                                <li className="nav-item has-treeview">
                                    <a href="" className='nav-link'>
                                        <p>Project Management <i className="fas fa-angle-right right" /></p>
                                    </a>
                                        
                                    <ul className="nav nav-treeview">
                                        
                                        {/* โครงการทั่้งหมด */}
                                        {((this.state.user_permissions[23].permission == 1 || this.state.user_permissions[27].permission == 1 || this.state.user_permissions[31].permission == 1 || this.state.user_permissions[17].permission == 1) &&
                                        <li className='nav-item has-treeview'>
                                            <a href="" className='nav-link'>
                                                <img src={"../dist/img/icon/ic_tips_01.png"} className="menu-icon" alt="" />
                                                    <p>โครงการทั้งหมด <i className="fas fa-angle-right right" /></p>
                                            </a>

                                            <ul className="nav nav-treeview">
                                                <li className="nav-item">
                                                    <NavLink to="/hometype" className="nav-link">
                                                        <i className="far fa-circle nav-icon" />
                                                        <p>ประเภทที่อยู่อาศัย</p>
                                                    </NavLink>
                                                </li>
                                                {(this.state.user_permissions[27].permission == 1 &&
                                                <li className="nav-item" >
                                                        <NavLink to="/projecttype" className="nav-link">
                                                            <i className="far fa-circle nav-icon" />
                                                            <p>แบรนด์</p>
                                                        </NavLink>
                                                    </li>)}

                                                {(this.state.user_permissions[31].permission == 1 &&
                                                    <li className="nav-item">
                                                        <NavLink to="/projecthome" className="nav-link">
                                                            <i className="far fa-circle nav-icon" />
                                                            <p>ชื่อโครงการ</p>
                                                        </NavLink>
                                                    </li>)}

                                                {(this.state.user_permissions[17].permission == 1 &&
                                                    <li className="nav-item">
                                                        <NavLink to="/residence" className="nav-link">
                                                            <i className="far fa-circle nav-icon" />
                                                            <p>บ้านเลขที่</p>
                                                        </NavLink>
                                                    </li>)}
                                            </ul>
                                        </li>)}


                                        {(this.state.user_permissions[142].permission == 1 &&
                                            <li className="nav-item has-treeview">
                                                <NavLink to="/projectdetail" className="nav-link">
                                                    <img src={"../dist/img/icon/ic_home_01.png"} className="menu-icon" alt="" />
                                                    <p>โครงการบ้าน</p>
                                                </NavLink>
                                            </li>
                                        )}

                                        {(this.state.user_permissions[156].permission == 1 &&
                                            <li className="nav-item has-treeview">
                                                <NavLink to="/emergencycall" className="nav-link">
                                                    <img src={"../dist/img/icon/ic_member_01.png"} className="menu-icon" alt="" />
                                                    <p>เบอร์โทรฉุกเฉิน</p>
                                                </NavLink>
                                            </li>
                                        )}

                                        {(this.state.user_permissions[100].permission == 1 &&
                                            <li className="nav-item has-treeview">
                                            <NavLink to="/level-member" className="nav-link">
                                                <img src={"../dist/img/icon/ic_member_01.png"} className="menu-icon" alt="" />
                                                <p>ระดับสมาชิก</p>
                                            </NavLink>
                                        </li>)}
                                    </ul>
                                
                                </li>)}

                                
                                {/* Member Managementv */}
                                {((this.state.user_permissions[3].permission == 1 || 
                                    this.state.user_permissions[7].permission == 1 || 
                                    this.state.user_permissions[11].permission == 1 || 
                                    this.state.user_permissions[183].permission == 1 || 
                                    this.state.user_permissions[217].permission == 1 || 
                                    this.state.user_permissions[15].permission == 1 || 
                                    this.state.user_permissions[221].permission == 1) &&
                                <li className="nav-item has-treeview">
                                    <a href="" className='nav-link'>
                                        <p>Member Management<i className="fas fa-angle-right right" /></p>
                                    </a>

                                    <ul className="nav nav-treeview">

                                        {((this.state.user_permissions[3].permission == 1 || this.state.user_permissions[7].permission == 1 || this.state.user_permissions[11].permission == 1 || this.state.user_permissions[183].permission == 1 || this.state.user_permissions[217].permission == 1) &&
                                            <li className="nav-item has-treeview">
                                                <a href="" className="nav-link">
                                                    <img src={"../dist/img/icon/ic_member_01.png"} className="menu-icon" alt="" />
                                                    <p>สมาชิก<i className="fas fa-angle-right right" /></p>
                                                </a>
                                                <ul className="nav nav-treeview">
                                                    {(this.state.user_permissions[3].permission == 1 &&
                                                        <li className="nav-item">
                                                            <NavLink to="/member" className="nav-link">
                                                                <i className="far fa-circle nav-icon" />
                                                                <p>ลูกบ้าน / รอโอน</p>
                                                            </NavLink>
                                                        </li>)}
                                                        
                                                    {(this.state.user_permissions[7].permission == 1 &&
                                                        <li className="nav-item" >
                                                            <NavLink to="/memberresident" className="nav-link">
                                                                <i className="far fa-circle nav-icon" />
                                                                <p>ผู้อาศัย / ผู้เช่า</p>
                                                            </NavLink>
                                                        </li>)}

                                                    {/* {(this.state.user_permissions[11].permission == 1 &&
                                                        <li className="nav-item">
                                                            <NavLink to="/memberguest" className="nav-link">
                                                                <i className="far fa-circle nav-icon" />
                                                                <p>ลูกค้าทั่วไป</p>
                                                            </NavLink>
                                                        </li>)} */}

                                                    {/* hiddden mini-phase 1 */}
                                                    {(this.state.user_permissions[217].permission == 1 &&
                                                        <li className="nav-item">
                                                            <NavLink to="/membercancel" className="nav-link">
                                                                <i className="far fa-circle nav-icon" />
                                                                <p>ลูกค้ายกเลิก (Cancel)</p>
                                                            </NavLink>
                                                        </li>)}
                                                    {(this.state.user_permissions[217].permission == 1 &&
                                                        <li className="nav-item">
                                                            <NavLink to="/memberdelete" className="nav-link">
                                                                <i className="far fa-circle nav-icon" />
                                                                <p>ลูกค้ายกเลิก (Delete)</p>
                                                            </NavLink>
                                                        </li>)}

                                                    {/* {(this.state.user_permissions[183].permission == 1 &&
                                                        <li className="nav-item">
                                                            <NavLink to="/memberproperty" className="nav-link">
                                                                <i className="far fa-circle nav-icon" />
                                                                <p>Admin Team Test</p>
                                                            </NavLink>
                                                        </li>)} */}

                                                </ul>
                                            </li>

                                        )} 

                                        {/* ลูกบ้านลงทะเบียน */}
                                        {((this.state.user_permissions[15].permission == 1 || this.state.user_permissions[221].permission == 1) &&
                                            <li className="nav-item has-treeview">
                                                <a href="" className="nav-link">
                                                    <img src={"../dist/img/icon/ic_member_01.png"} className="menu-icon" alt="" />
                                                    <p>ลูกบ้านลงทะเบียน<i className="fas fa-angle-right right" /></p>
                                                </a>
                                                <ul className="nav nav-treeview">
                                                    {(this.state.user_permissions[15].permission == 1 &&
                                                        <li className="nav-item">
                                                            <NavLink to="/memberapprove" className="nav-link">
                                                                <i className="far fa-circle nav-icon" />
                                                                <p>รออนุมัติ</p>
                                                            </NavLink>
                                                        </li>)}
                                                    {(this.state.user_permissions[221].permission == 1 &&
                                                        <li className="nav-item">
                                                            <NavLink to="/memberauto" className="nav-link">
                                                                <i className="far fa-circle nav-icon" />
                                                                <p>Auto Approve</p>
                                                            </NavLink>
                                                        </li>)}
                                                    
                                                </ul>
                                            </li>
                                        )}
                                    </ul>
                                </li>)}

                                                            
                                {/* Perfect Service */}
                                {/* {((this.state.user_permissions[3].permission == 1 || 
                                    this.state.user_permissions[7].permission == 1 || 
                                    this.state.user_permissions[11].permission == 1 || 
                                    this.state.user_permissions[183].permission == 1 || 
                                    this.state.user_permissions[217].permission == 1 || 
                                    this.state.user_permissions[15].permission == 1 || 
                                    this.state.user_permissions[221].permission == 1) && */}


                                {((this.state.user_permissions[250].permission == 1 || 
                                    this.state.user_permissions[47].permission == 1 || 
                                    this.state.user_permissions[51].permission == 1 || 
                                    this.state.user_permissions[188].permission == 1 || 
                                    this.state.user_permissions[55].permission == 1 || 
                                    this.state.user_permissions[198].permission == 1 || 
                                    this.state.user_permissions[205].permission == 1 || 
                                    this.state.user_permissions[59].permission == 1 || 
                                    this.state.user_permissions[61].permission == 1 || 
                                    this.state.user_permissions[63].permission == 1 || 
                                    this.state.user_permissions[209].permission == 1) &&
                                    <li className="nav-item has-treeview">
                                        <a href="" className="nav-link">
                                            <p>Perfect Service<i className="fas fa-angle-right right" /></p>
                                        </a>
                                        <ul className="nav nav-treeview">
                                            {((this.state.user_permissions[250].permission == 1) &&
                                                <li className="nav-item">
                                                    <NavLink to="/all-case" className="nav-link">
                                                        <img src={"../dist/img/icon/callcenter.png"} style={{ width: "25px" }} className="menu-icon" alt="" />
                                                        <p>Perfect Service</p>
                                                    </NavLink>
                                                </li>
                                            )}
                                            {((this.state.user_permissions[47].permission == 1 || this.state.user_permissions[51].permission == 1 || this.state.user_permissions[188].permission == 1 || this.state.user_permissions[55].permission == 1) &&
                                                <li className="nav-item has-treeview">
                                                    <a href="" className="nav-link">
                                                        <img src={"../dist/img/icon/ic-jur-3.png"} className="menu-icon" alt="" />
                                                        <p>แจ้งซ่อม / ร้องเรียน ส่วนกลาง<i className="fas fa-angle-right right" /></p>
                                                    </a>
                                                    <ul className="nav nav-treeview">
                                                        {(this.state.user_permissions[47].permission == 1 &&
                                                            <li className="nav-item">
                                                                <NavLink to="/juristicworksheet" className="nav-link">
                                                                    <i className="far fa-circle nav-icon" />
                                                                    <p>ใบงานแจ้งซ่อมส่วนกลาง</p>
                                                                </NavLink>
                                                            </li>)}
                                                            {/* flags mini phase1 */}
                                                        {/* {(this.state.user_permissions[51].permission == 1 &&
                                                            <li className="nav-item" >
                                                                <NavLink to="/juristicmainservice" className="nav-link">
                                                                    <i className="far fa-circle nav-icon" />
                                                                    <p>หัวข้อหลัก</p>
                                                                </NavLink>
                                                            </li>)} */}
                                                        {(this.state.user_permissions[188].permission == 1 &&
                                                            <li className="nav-item" >
                                                                <NavLink to="/juristicgroupservice" className="nav-link">
                                                                    <i className="far fa-circle nav-icon" />
                                                                    <p>กลุ่มหัวข้อ</p>
                                                                </NavLink>
                                                            </li>)}
                                                        {(this.state.user_permissions[55].permission == 1 &&
                                                            <li className="nav-item">
                                                                <NavLink to="/juristicsubservice" className="nav-link">
                                                                    <i className="far fa-circle nav-icon" />
                                                                    <p>หัวข้อย่อย</p>
                                                                </NavLink>
                                                            </li>)}
                                                    </ul>
                                                </li>
                                            )}


                                            {((this.state.user_permissions[198].permission == 1 || this.state.user_permissions[205].permission == 1 || this.state.user_permissions[209].permission == 1) &&
                                                <li className="nav-item has-treeview">
                                                    <a href="" className="nav-link">
                                                        <img src={"../dist/img/icon/receive.png"} style={{ width: "25px" }} className="menu-icon" alt="" />
                                                        <p>ร้องเรียน / ข้อเสนอแนะทั่วไป <i className="fas fa-angle-right right" /></p>
                                                    </a>
                                                    <ul className="nav nav-treeview">
                                                        {(this.state.user_permissions[198].permission == 1 &&
                                                            <li className="nav-item">
                                                                <NavLink to="/callcenterworksheet" className="nav-link">
                                                                    <i className="far fa-circle nav-icon" />
                                                                    <p>ใบงานเสนอแนะ</p>
                                                                </NavLink>
                                                            </li>)}

                                                            {/* flags hidden */}
                                                        {/* {(this.state.user_permissions[201].permission == 1 &&
                                                            <li className="nav-item" >
                                                                <NavLink to="/callcentermainservice" className="nav-link">
                                                                    <i className="far fa-circle nav-icon" />
                                                                    <p>หัวข้อหลัก</p>
                                                                </NavLink>
                                                            </li>)} */}
                                                        {(this.state.user_permissions[205].permission == 1 &&
                                                            <li className="nav-item" >
                                                                <NavLink to="/callcentergroupservice" className="nav-link">
                                                                    <i className="far fa-circle nav-icon" />
                                                                    <p>กลุ่มหัวข้อ</p>
                                                                </NavLink>
                                                            </li>)}
                                                        {(this.state.user_permissions[209].permission == 1 &&
                                                            <li className="nav-item">
                                                                <NavLink to="/callcentersubservice" className="nav-link">
                                                                    <i className="far fa-circle nav-icon" />
                                                                    <p>หัวข้อย่อย</p>
                                                                </NavLink>
                                                            </li>)}
                                                    </ul>
                                                </li>
                                            )} 
                                            {((this.state.user_permissions[59].permission == 1 || this.state.user_permissions[61].permission == 1 || this.state.user_permissions[63].permission == 1) &&
                                                <li className="nav-item has-treeview">
                                                    <a href="" className="nav-link">
                                                        <img src={"../dist/img/icon/ic_report_01.png"} className="menu-icon" alt="" />
                                                        <p>รายงาน<i className="fas fa-angle-right right" /></p>
                                                    </a>
                                                    <ul className="nav nav-treeview">
                                                        {(this.state.user_permissions[61].permission == 1 &&
                                                            <li className="nav-item">
                                                                <NavLink to="/reportjuristic" className="nav-link">
                                                                    <i className="far fa-circle nav-icon" />
                                                                    <p>แจ้งซ่อม/ร้องเรียน ส่วนกลาง</p>
                                                                </NavLink>
                                                            </li>)}
                                                        {(this.state.user_permissions[59].permission == 1 &&
                                                            <li className="nav-item">
                                                                <NavLink to="/reporthomecare" className="nav-link">
                                                                    <i className="far fa-circle nav-icon" />
                                                                    <p>ร้องเรียน/ข้อเสนอแนะทั่วไป</p>
                                                                </NavLink>
                                                            </li>)}
                                                        {/* {(this.state.user_permissions[63].permission == 1 &&
                                                            <li className="nav-item">
                                                                <a href="/reportpresale" className="nav-link">
                                                                    <i className="far fa-circle nav-icon"></i>
                                                                    <p>Presale</p>
                                                                </a>
                                                            </li>)} */}
                                                        {/* {(this.state.user_permissions[63].permission == 1 &&
                                                            <li className="nav-item">
                                                                <NavLink to="/reportpresale" className="nav-link">
                                                                    <i className="far fa-circle nav-icon" />
                                                                    <p>Presale</p>
                                                                </NavLink>
                                                            </li>)} */}
                                                    </ul>
                                                </li>
                                            )}
                                            
                                        </ul>
                                    </li>
                                )}
                            
                                {/* Friend Get Friend */}
                                {((this.state.user_permissions[100].permission == 1 ) &&
                                        <li className="nav-item has-treeview">
                                            <a href="" className="nav-link">
                                                <p>Member Get Member <i className="fas fa-angle-right right" /></p>
                                            </a>

                                            <ul className="nav nav-treeview">
                                                <li className='nav-item has-treeview'>
                                                    <a href="" className='nav-link'>
                                                        <img src={"../dist/img/icon/ic_campaing_01.png"} className="menu-icon" alt="" />
                                                            <p>สิทธิประโยชน์ <i className="fas fa-angle-right right" /></p>
                                                    </a>
                                                    

                                                <ul className="nav nav-treeview">
                                                    <li className="nav-item">
                                                        <NavLink to="/privilegemgm" className="nav-link">
                                                            <i className="far fa-circle nav-icon" />
                                                            <p>Member Get Member</p>
                                                        </NavLink>
                                                    </li>
                                                    {(this.state.user_permissions[27].permission == 1 &&
                                                    <li className="nav-item" >
                                                            <NavLink to="/mgmtransaction" className="nav-link">
                                                                <i className="far fa-circle nav-icon" />
                                                                <p>ประวัติแคมเปญ(MGM)</p>
                                                            </NavLink>
                                                        </li>)}

                                                </ul>
                                             </li>

                                            </ul>
                                            
                                           
                                        </li>
                                    )}
                                {/* Community Management */}
                                {((this.state.user_permissions[74].permission == 1 ) &&
                                    <li className="nav-item has-treeview">
                                        <a href="" className="nav-link">
                                            <p>Community Management<i className="fas fa-angle-right right" /></p>
                                        </a>
                                        <ul className="nav nav-treeview">
                                        {((this.state.user_permissions[100].permission == 1 || this.state.user_permissions[104].permission == 1 || this.state.user_permissions[108].permission == 1 || this.state.user_permissions[109].permission == 1 || this.state.user_permissions[113].permission == 1) &&
                                            <li className="nav-item has-treeview">
                                                <a href="" className="nav-link">
                                                    <img src={"../dist/img/icon/ic_campaing_01.png"} className="menu-icon" alt="" />
                                                    <p> สิทธิประโยชน์<i className="fas fa-angle-right right" /> </p>
                                                </a>
                                                <ul className="nav nav-treeview">
                                                
                                                    {(this.state.user_permissions[104].permission == 1 &&
                                                        <li className="nav-item">
                                                            <NavLink to="/privilegeevent" className="nav-link">
                                                                <i className="far fa-circle nav-icon" />
                                                                <p>กิจกรรม</p>
                                                            </NavLink>
                                                        </li>)}
                                                    {(this.state.user_permissions[108].permission == 1 &&
                                                        <li className="nav-item">
                                                            <NavLink to="/privilegeeventtransaction" className="nav-link">
                                                                <i className="far fa-circle nav-icon" />
                                                                <p>ประวัติกิจกรรม</p>
                                                            </NavLink>
                                                        </li>)}
                                                 
                                                </ul>
                                            </li>
                                        )}
                                        </ul>
                                    </li>
                                )}
                                    
                                {/* Reward Management */}
                                {((this.state.user_permissions[100].permission == 1 || this.state.user_permissions[104].permission == 1 || this.state.user_permissions[108].permission == 1 || this.state.user_permissions[109].permission == 1 || this.state.user_permissions[113].permission == 1) &&
                                        <li className="nav-item has-treeview">
                                            <a href="" className="nav-link">
                                                <p>Reward Management <i className="fas fa-angle-right right" /></p>
                                            </a>
                                            {((this.state.user_permissions[100].permission == 1 || this.state.user_permissions[104].permission == 1 || this.state.user_permissions[108].permission == 1 || this.state.user_permissions[109].permission == 1 || this.state.user_permissions[113].permission == 1) &&
                                            <ul className="nav nav-treeview">
                                                <li className='nav-item has-treeview'>
                                                    <a href="" className='nav-link'>
                                                        <img src={"../dist/img/icon/ic_campaing_01.png"} className="menu-icon" alt="" />
                                                        <p>รีวอร์ด - พอยท์<i className="fas fa-angle-right right" /> </p>
                                                    </a>
                                                    
                                                <ul className="nav nav-treeview">
                                                    <li className="nav-item">
                                                        <NavLink to="/category-point" className="nav-link">
                                                            <i className="far fa-circle nav-icon" />
                                                            <p>หมวดหมู่</p>
                                                        </NavLink>
                                                    </li>
                                                    <li className="nav-item">
                                                        <NavLink to="/point" className="nav-link">
                                                            <i className="far fa-circle nav-icon" />
                                                            <p>รายการ</p>
                                                        </NavLink>
                                                    </li>
                                                    <li className="nav-item">
                                                        <NavLink to="/history-point" className="nav-link">
                                                            <i className="far fa-circle nav-icon" />
                                                            <p>ประวัติการใช้งาน</p>
                                                        </NavLink>
                                                    </li>
                                                </ul>
                                             </li>
                                            </ul>)}
                                            
                                            {((this.state.user_permissions[100].permission == 1 || this.state.user_permissions[104].permission == 1 || this.state.user_permissions[108].permission == 1 || this.state.user_permissions[109].permission == 1 || this.state.user_permissions[113].permission == 1) &&
                                            <ul className="nav nav-treeview">
                                                <li className='nav-item has-treeview'>
                                                    <a href="" className='nav-link'>
                                                        <img src={"../dist/img/icon/ic_campaing_01.png"} className="menu-icon" alt="" />
                                                        <p>รีวอร์ด - สิทธิพิเศษ<i className="fas fa-angle-right right" /> </p>
                                                    </a>
                                                    
                                                <ul className="nav nav-treeview">
                                                <li className="nav-item">
                                                    <NavLink to="/category-privilege" className="nav-link">
                                                        <i className="far fa-circle nav-icon" />
                                                        <p>หมวดหมู่</p>
                                                    </NavLink>
                                                </li>
                                                <li className="nav-item">
                                                    <NavLink to="/privilege" className="nav-link">
                                                        <i className="far fa-circle nav-icon" />
                                                        <p>รายการ</p>
                                                    </NavLink>
                                                </li>
                                                <li className="nav-item">
                                                    <NavLink to="/history-privilege" className="nav-link">
                                                        <i className="far fa-circle nav-icon" />
                                                        <p>ประวัติการใช้งาน</p>
                                                    </NavLink>
                                                </li>
                                                </ul>
                                             </li>
                                            </ul>)}

                                            {((this.state.user_permissions[100].permission == 1 || this.state.user_permissions[104].permission == 1 || this.state.user_permissions[108].permission == 1 || this.state.user_permissions[109].permission == 1 || this.state.user_permissions[113].permission == 1) &&
                                            <ul className="nav nav-treeview">
                                                <li className='nav-item has-treeview'>
                                                    <a href="" className='nav-link'>
                                                        <img src={"../dist/img/icon/ic_campaing_01.png"} className="menu-icon" alt="" />
                                                        <p>รีวอร์ด - แลกคะแนน<i className="fas fa-angle-right right" /> </p>
                                                    </a>
                                                    
                                                <ul className="nav nav-treeview">
                                                    <li className="nav-item">
                                                        <NavLink to="/category-transfer" className="nav-link">
                                                            <i className="far fa-circle nav-icon" />
                                                            <p>หมวดหมู่</p>
                                                        </NavLink>
                                                    </li>
                                                    <li className="nav-item">
                                                        <NavLink to="/transferpoint" className="nav-link">
                                                            <i className="far fa-circle nav-icon" />
                                                            <p>รายการ</p>
                                                        </NavLink>
                                                    </li>
                                                    <li className="nav-item">
                                                        <NavLink to="/history-transfer" className="nav-link">
                                                            <i className="far fa-circle nav-icon" />
                                                            <p>ประวัติการใช้งาน</p>
                                                        </NavLink>
                                                    </li>
                                                </ul>
                                             </li>
                                            </ul>)}
                                            
                                        </li>
                                    )}
                                 

                                {/* Point Management */}
                                {((this.state.user_permissions[109].permission == 1 ) &&
                                    <li className="nav-item has-treeview">
                                        <a href="" className="nav-link">
                                            <p>Point Management<i className="fas fa-angle-right right" /></p>
                                        </a>
                                        <ul className="nav nav-treeview">
                                            {((this.state.user_permissions[100].permission == 1 || this.state.user_permissions[104].permission == 1 || this.state.user_permissions[108].permission == 1 || this.state.user_permissions[109].permission == 1 || this.state.user_permissions[113].permission == 1) &&
                                                <li className="nav-item has-treeview">
                                                    <a href="" className="nav-link">
                                                        <img src={"../dist/img/icon/ic_campaing_01.png"} className="menu-icon" alt="" />
                                                        <p> จัดการแต้ม<i className="fas fa-angle-right right" /> </p>
                                                    </a>
                                                    <ul className="nav nav-treeview">
                                                        {(this.state.user_permissions[100].permission == 1 &&
                                                            <li className="nav-item">
                                                                <NavLink to="/memberpointtransaction" className="nav-link">
                                                                    <i className="far fa-circle nav-icon" />
                                                                    <p>เพิ่มแต้มให้สมาชิก</p>
                                                                </NavLink>
                                                            </li>)}
                                                            {(this.state.user_permissions[100].permission == 1 &&
                                                            <li className="nav-item">
                                                                <NavLink to="/memberpointapprove" className="nav-link">
                                                                    <i className="far fa-circle nav-icon" />
                                                                    <p>ระบบจัดการอนุมัติแต้ม</p>
                                                                </NavLink>
                                                            </li>)}
                                                    </ul>
                                                </li>
                                            )}
                                        </ul>
                                    </li>
                                )}
                                {((this.state.user_permissions[134].permission == 1 || 
                                    this.state.user_permissions[150].permission == 1 || 
                                    this.state.user_permissions[154].permission == 1 || 
                                    this.state.user_permissions[170].permission == 1 || 
                                    this.state.user_permissions[247].permission == 1) &&
                                    <li className="nav-item has-treeview">
                                        <a href="" className="nav-link">
                                            <p>Content Management<i className="fas fa-angle-right right" /></p>
                                        </a>
                                        <ul className="nav nav-treeview">
                                            {((this.state.user_permissions[134].permission == 1) &&
                                                <li className="nav-item has-treeview">
                                                    <a href="" className="nav-link">
                                                        <img src={"../dist/img/icon/ic_banner_01.png"} className="menu-icon" alt="" />
                                                        <p>จัดการ Banner <i className="fas fa-angle-right right" /> </p>
                                                    </a>
                                                    <ul className="nav nav-treeview">
                                                        {(this.state.user_permissions[134].permission == 1 &&
                                                            <li className="nav-item">
                                                                <NavLink to="/bannerhome" className="nav-link">
                                                                    <i className="far fa-circle nav-icon" />
                                                                    <p>Home Banner</p>
                                                                </NavLink>
                                                            </li>)}
                                                        {/* {(this.state.user_permissions[138].permission == 1 &&
                                                            <li className="nav-item">
                                                                <NavLink to="/bannerpromotion" className="nav-link">
                                                                    <i className="far fa-circle nav-icon" />
                                                                    <p>Promotion Banner</p>
                                                                </NavLink>
                                                            </li>)} */}
                                                    </ul>
                                                </li>)}

                                                {(this.state.user_permissions[150].permission == 1 &&
                                                    <li className="nav-item has-treeview">
                                                        <NavLink to="/aboutus" className="nav-link">
                                                            <img src={"../dist/img/icon/ic_tips_01.png"} className="menu-icon" alt="" />
                                                            <p> เกี่ยวกับเรา </p>
                                                        </NavLink>
                                                    </li>
                                                )}

                                                {(this.state.user_permissions[154].permission == 1 &&
                                                    <li className="nav-item has-treeview">
                                                        <NavLink to="/contactus" className="nav-link">
                                                            <img src={"../dist/img/icon/ic_contact_us.png"} className="menu-icon" alt="" />
                                                            <p>ติดต่อเรา</p>
                                                        </NavLink>
                                                    </li>
                                                )}

                                                {((this.state.user_permissions[170].permission == 1 || this.state.user_permissions[172].permission == 1 || this.state.user_permissions[247].permission == 1) &&
                                                        <li className="nav-item has-treeview">
                                                            <a href="" className="nav-link">
                                                                <img src={"../dist/img/icon/ic_tips_01.png"} className="menu-icon" alt="" />
                                                                <p>นโยบาย<i className="fas fa-angle-right right" /></p>
                                                            </a>
                                                            <ul className="nav nav-treeview">
                                                                {(this.state.user_permissions[170].permission == 1 &&
                                                                    <li className="nav-item">
                                                                        <NavLink to="/policy" className="nav-link">
                                                                            <i className="far fa-circle nav-icon" />
                                                                            <p>นโยบายความเป็นส่วนต้ว</p>
                                                                        </NavLink>
                                                                    </li>)}
                                                                {/* {(this.state.user_permissions[170].permission == 1 &&
                                                                    <li className="nav-item">
                                                                        <NavLink to="/consent" className="nav-link">
                                                                            <i className="far fa-circle nav-icon" />
                                                                            <p>การขอความยินยอม</p>
                                                                        </NavLink>
                                                                    </li>)} */}
                                                                {(this.state.user_permissions[247].permission == 1 &&
                                                                    <li className="nav-item">
                                                                        <NavLink to="/policytracking" className="nav-link">
                                                                            <i className="far fa-circle nav-icon" />
                                                                            <p>รายงานลูกบ้าน</p>
                                                                        </NavLink>
                                                                    </li>)}
                                                                {/* {(this.state.user_permissions[172].permission == 1 &&
                                                                    <li className="nav-item">
                                                                        <NavLink to="/policytrackingpresale" className="nav-link">
                                                                            <i className="far fa-circle nav-icon" />
                                                                            <p>รายงานลูกค้าทั่วไป</p>
                                                                        </NavLink>
                                                                    </li>)} */}
                                                            </ul>
                                                        </li>
                                                    )}
                                        </ul>
                                    </li>
                                )}

                                {/* Admin Management */}
                                {((this.state.user_permissions[174].permission == 1 || this.state.user_permissions[179].permission == 1 || this.state.user_permissions[197].permission == 1 || this.state.user_permissions[187].permission == 1) &&
                                    <li className="nav-item has-treeview">
                                        <a href="" className="nav-link">
                                            <p>Admin Management<i className="fas fa-angle-right right" /></p>
                                        </a>
                                        <ul className="nav nav-treeview">
                                        {/* {((this.state.user_permissions[174].permission == 1 || this.state.user_permissions[179].permission == 1 || this.state.user_permissions[197].permission == 1 || this.state.user_permissions[187].permission == 1) && */}
                                            <li className="nav-item has-treeview">
                                                <a href="" className="nav-link">
                                                    <img src={"../dist/img/icon/ic-system_01.png"} className="menu-icon" alt="" />
                                                    <p>ตั้งค่าแอดมิน<i className="fas fa-angle-right right" /></p>
                                                </a>

                                                <ul className="nav nav-treeview">
                                                    {(this.state.user_permissions[174].permission == 1 &&
                                                        <li className="nav-item">
                                                            <NavLink to="/permission" className="nav-link">
                                                                <i className="far fa-circle nav-icon" />
                                                                <p>อนุมัติสิทธิ</p>
                                                            </NavLink>
                                                        </li>)}
                                                    {(this.state.user_permissions[179].permission == 1 &&
                                                        <li className="nav-item">
                                                            <NavLink to="/users" className="nav-link">
                                                                <i className="far fa-circle nav-icon" />
                                                                <p>ผู้ใช้</p>
                                                            </NavLink>
                                                        </li>)}
                                                    {(this.state.user_permissions[197].permission == 1 &&
                                                        <li className="nav-item">
                                                            <NavLink to="/configemail" className="nav-link">
                                                                <i className="far fa-circle nav-icon" />
                                                                <p>ตั้งค่าอีเมล</p>
                                                            </NavLink>
                                                        </li>)}
                                                    {(this.state.user_permissions[187].permission == 1 &&
                                                        <li className="nav-item">
                                                            <NavLink to="/memberlogs" className="nav-link">
                                                                <i className="far fa-circle nav-icon" />
                                                                <p>ประวัติการใช้งานสมาชิก</p>
                                                            </NavLink>
                                                        </li>)}
                                                </ul>
                                            </li>
                                        </ul>
                                    </li>
                                )}

                                {(this.state.user_permissions[65].permission == 1 &&
                                    <li className="nav-item has-treeview">
                                        <NavLink to="/paymentamount" className="nav-link">
                                            <img src={"../dist/img/icon/ic_payment_01.png"} className="menu-icon" alt="" />
                                            <p>งวดดาวน์</p>
                                        </NavLink>
                                    </li>
                                )}

                                {(this.state.user_permissions[95].permission == 1 &&
                                    <li className="nav-item has-treeview">
                                        <NavLink to="/houseprogress" className="nav-link">
                                            <img src={"../dist/img/icon/ic_home_01.png"} className="menu-icon" alt="" />
                                            <p>งานก่อสร้างโครงการ</p>
                                        </NavLink>
                                    </li>
                                )}
                                
                                </>
                        </ul>
                    </nav>
                </div>
                <Modal show={this.state.logoutIsOpen} onHide={this.closeLogoutCancel}>
                    <ModalHeader>
                        <ModalTitle>ผลการตรวจสอบ</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <h3>คุณต้องการออกจากระบบใช่หรือไม่</h3>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeLogoutCancel}>ยกเลิก</button>
                        <button className="btn btn-info" onClick={this.LogoutSubmit}>ตกลง</button>
                    </ModalFooter>
                </Modal>
            </aside>
        );
    }
}